var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"my-10",attrs:{"height":_vm.height,"width":_vm.width,"contain":"","lazy-src":("" + _vm.path + _vm.value + _vm.typeFile),"src":("" + _vm.path + _vm.value + _vm.typeFile)}})}
var staticRenderFns = []

export { render, staticRenderFns }